import React, { Component } from 'react';
import { Cascader } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';

class CascaderCounty extends Component {
    state = {
        options: [],
    }

    componentDidMount() {
        this.queryData( res => {                 
            const { datas = [] } = res;
            const options = datas.map(d => ({      
                value: d.regionId,
                label: d.regionName,
                children: d.children.map(i => ({
                    value: i.regionId,
                    label: i.regionName,
                    children: i.children?i.children.map(j => ({
                        value: j.regionId,
                        label: j.regionName,
                    })):undefined
                })),
            }));
            this.setState({ options });
        });
    }

    queryData = ( func ) => {    
        const options = {
            method: 'POST',
            url: API_URL.common.getRegionTree,
            data: { },
            dataType: 'json',
            doneResult: func,
        };
        $.sendRequest(options);
    }

    onChange = (value, selectedOptions) => {
        this.props.onChange(value, selectedOptions);
    }

    render() {
        const { options } = this.state;
        const { style, value, placeholder, className = '' } = this.props;
        return (
            <Cascader
                style={style}
                value={value}
                className={className}
                placeholder={placeholder || '请选择'}
                options={options}
                onChange={this.onChange}
                changeOnSelect
            />
        );
    }
}

export default CascaderCounty;



// WEBPACK FOOTER //
// ./src/components/common/CascaderCounty.js